module.exports = __webpack_public_path__ + "img/camera_blue.2589ec04.svg";